import { render, staticRenderFns } from "./SelectInputResourcefulV2.vue?vue&type=template&id=44c4f4f4&"
import script from "./SelectInputResourcefulV2.vue?vue&type=script&lang=js&"
export * from "./SelectInputResourcefulV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports